import type { AudienceFilterDto } from "@intelligems/ig-types/dtos/audiences";

export const hasPurchaseLikelihoodAudienceFilter = (
  filters: AudienceFilterDto[] | undefined | null
): boolean =>
  Boolean(
    filters?.some((filter) =>
      filter.expression?.some(
        (node) => node.query?.type === "purchaseLikelihood"
      )
    )
  );
